import React from "react";
import { X } from "lucide-react";
import { Button } from "../../shadcn/ui/Button";
import { Badge } from "../../shadcn/ui/Badge";

export interface ActiveFilter {
  key: string;
  label: string;
  value: string;
  onRemove: () => void;
}

export interface ActiveFiltersBarProps {
  filters: ActiveFilter[];
  onClearAll: () => void;
}

export const ActiveFiltersBar: React.FC<ActiveFiltersBarProps> = ({
  filters,
  onClearAll,
}) => {
  if (filters.length === 0) {
    return null;
  }

  return (
    <div className="flex items-center gap-2 flex-wrap py-3 px-4 bg-gray-50 border-b border-gray-200">
      <span className="text-sm text-gray-600 font-medium">Active Filters:</span>
      {filters.map((filter) => (
        <Badge
          key={filter.key}
          variant="secondary"
          className="flex items-center gap-1 px-2 py-1 text-xs bg-white border border-gray-300 hover:bg-gray-100"
        >
          <span>
            {filter.label}: {filter.value}
          </span>
          <button
            onClick={filter.onRemove}
            className="ml-1 hover:bg-gray-200 rounded-full p-0.5 transition-colors"
            aria-label={`Remove ${filter.label} filter`}
          >
            <X className="h-3 w-3" />
          </button>
        </Badge>
      ))}
      <Button
        variant="ghost"
        size="sm"
        onClick={onClearAll}
        className="text-xs text-[#F97316] hover:text-[#ea6820] hover:bg-orange-50 h-6 px-2"
      >
        Clear All
      </Button>
    </div>
  );
};

